// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__HClHj"};